import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=0db5f175&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"
import style0 from "./videos.vue?vue&type=style&index=0&id=0db5f175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5f175",
  null
  
)

export default component.exports